"use client";

/**
 * ConfirmStep — final review before run.
 *
 * Renders the resolved target list + action extras and asks user to confirm.
 */

import { Button } from "@west-tennessee-consulting/ui";

import type { ConfirmSummary } from "@/lib/actions/resolution/types";

import { useResolverContext } from "../ResolverContext";

interface Props {
  summary: ConfirmSummary;
}

export function ConfirmStep({ summary }: Props) {
  const { setConfirmed, close } = useResolverContext();

  return (
    <div className="space-y-4">
      <div className="space-y-2 text-sm">
        <div>
          <span className="text-muted-foreground">Action:</span>{" "}
          <span className="font-medium">{summary.actionLabel}</span>
        </div>
        <div>
          <span className="text-muted-foreground">Target:</span>{" "}
          <span className="font-medium">
            {summary.targetIds.length} {summary.targetEntity}
            {summary.targetIds.length === 1 ? "" : "s"}
          </span>
        </div>
        {summary.walkLabel && (
          <div>
            <span className="text-muted-foreground">Resolved via:</span>{" "}
            <span className="font-medium">{summary.walkLabel}</span>
          </div>
        )}
        {Object.entries(summary.extras).map(([name, value]) => (
          <div key={name}>
            <span className="text-muted-foreground capitalize">
              {name}:
            </span>{" "}
            <span className="font-medium">
              {value.length > 200 ? `${value.slice(0, 200)}…` : value}
            </span>
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-2 pt-2">
        <Button variant="outline" onClick={close}>
          Cancel
        </Button>
        <Button onClick={() => setConfirmed(true)}>Confirm &amp; send</Button>
      </div>
    </div>
  );
}
